import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { logout } from 'external/firebase/controllers/auth';
import useAuth from 'hooks/useAuth';
import { Login } from 'pages';
import { PATH_AUTH, PATH_DASHBOARD } from 'routes/paths';

const AuthGuard: React.FunctionComponent = ({ children }) => {
    const { user, profile } = useAuth();
    const { pathname } = useLocation();
    const [requestedLocation, setRequestedLocation] = useState<string | null>(null);

    if (!user) {
        if (pathname !== requestedLocation) {
            setRequestedLocation(pathname);
        }
        return <Login />;
    }

    const isEmailVerified = user?.emailVerified || (profile?.role === 'teacher' && profile?.emailVerified);
    const shouldRedirectToVerifyPage = (!isEmailVerified || !profile?.role) && pathname !== PATH_AUTH.verify;
    if (shouldRedirectToVerifyPage) {
        return <Navigate to={PATH_AUTH.verify} replace />;
    }

    const shouldRedirectToDashboard = user && isEmailVerified && profile?.role && pathname === PATH_AUTH.verify;
    if (shouldRedirectToDashboard) {
        return <Navigate to={PATH_DASHBOARD.root} replace />;
    }

    if (requestedLocation && pathname !== requestedLocation) {
        setRequestedLocation(null);
        return <Navigate to={requestedLocation} />;
    }

    return <>{children}</>;
};

export default AuthGuard;
